import activationAxiosInstance from "app/activationAxiosInstance";
import { IPaymentMethodsResponse } from "app/data/types";
import { mockGetPaymentMethods } from "./ActivationPaymentMock";

/**
 * The single seam between mocked and real payment method data.
 *
 * Phase 1 runs against `ActivationPaymentMock`; phase 2 flips the flag and any
 * difference between the proposed and delivered contracts is absorbed here.
 * Nothing above this module — thunks, selectors, components — may branch on
 * which implementation is active.
 *
 * The real endpoint below is written against the contract proposed in design.md
 * and has never been called. It is unverified until the backend publishes the
 * delivered shape.
 */

export const isActivationPaymentEnabled = (): boolean =>
  process.env.REACT_APP_ACTIVATION_PAYMENT_ENABLED === "true";

export const isActivationPaymentMocked = (): boolean =>
  isActivationPaymentEnabled() &&
  process.env.REACT_APP_ACTIVATION_PAYMENT_MOCK === "true";

class ActivationPayment {
  static getPaymentMethods = async (
    activationCode: string
  ): Promise<{ status: number; data: IPaymentMethodsResponse }> => {
    if (isActivationPaymentMocked()) {
      return await mockGetPaymentMethods();
    }

    return await activationAxiosInstance.get(
      `/${activationCode}/payment-methods`,
      { headers: { isNotProtected: true } }
    );
  };
}

export default ActivationPayment;
